import { useEffect, useState } from 'react'
import { PLAYER_PLACEHOLDER_ID } from 'components/Player/Player'

const useFullscreen = (player: jwplayer.JWPlayer | null) => {
  const [container, setContainer] = useState<HTMLDivElement | null>(null)

  const [isFullscreen, setIsFullscreen] = useState(() =>
    Boolean(player?.getFullscreen()),
  )

  useEffect(() => {
    const portal = document?.getElementById(PLAYER_PLACEHOLDER_ID)
    const existingElement = portal?.querySelector('#container-id')
    if (!existingElement) {
      const div = document.createElement('div')
      div.setAttribute('id', 'container-id')

      portal?.insertBefore(div, portal.children[0])

      player?.on('fullscreen', ({ fullscreen }: { fullscreen: boolean }) => {
        setIsFullscreen(fullscreen)
      })

      setContainer(div)

      return () => {
        if (portal?.querySelector('#container-id')) {
          portal.removeChild(div)
        }
      }
    }
  }, [player])

  return { isFullscreen, container }
}

export default useFullscreen
